import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const comparisons = [{
  bad: 'Cerchi esercizi su Google per ore.',
  good: 'Verifiche pronte in 5 minuti.'
}, {
  bad: 'Domenica sera davanti al PC.',
  good: 'Fine settimana finalmente libero.'
}, {
  bad: "UDA scritte all'ultimo minuto.",
  good: 'Programmazione annuale già pronta.'
}, {
  bad: 'Studenti BES/DSA senza supporto.',
  good: 'PDP e mappe compensative incluse.'
}, {
  bad: 'Seconda Prova gestita con ansia.',
  good: 'Simulazioni e griglie ministeriali pronte.'
}, {
  bad: 'Griglie di valutazione improvvisate.',
  good: 'Griglie conformi MIM già pronte.'
}];
export function ComparisonTable() {
  return <section className="py-10 sm:py-12 px-4" data-id="element-48">
      <div className="max-w-5xl mx-auto" data-id="element-49">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-8 text-brand-cream" data-id="element-50">
          Senza il Metodo →{' '}
          <span className="text-brand-orange" data-id="element-51">Con il Metodo</span>
        </motion.h2>

        <div className="grid grid-cols-1 gap-4" data-id="element-52">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#1a0f0a] border border-red-900/50 rounded-2xl p-6 sm:p-8" data-id="element-53">
            <h3 className="text-2xl font-black text-red-500 mb-6 text-center uppercase tracking-wide" data-id="element-54">
              ❌ Oggi
            </h3>
            <div className="space-y-4" data-id="element-55">
              {comparisons.map((item, i) => <div key={i} className="flex gap-3 items-start" data-id="element-56">
                  <div className="mt-1 bg-red-500/20 p-1 rounded-full shrink-0" data-id="element-57">
                    <XIcon className="w-5 h-5 text-red-500" data-id="element-58" />
                  </div>
                  <p className="text-gray-300 font-medium" data-id="element-59">{item.bad}</p>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-b from-[#1a140a] to-[#0f0a05] border border-brand-orange/50 rounded-2xl p-6 sm:p-8 shadow-[0_0_30px_rgba(249,115,22,0.15)] relative overflow-hidden" data-id="element-60">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-orange to-brand-gold" data-id="element-61" />
            <h3 className="text-2xl font-black text-brand-gold mb-6 text-center uppercase tracking-wide" data-id="element-62">
              ✅ Da domani
            </h3>
            <div className="space-y-4" data-id="element-63">
              {comparisons.map((item, i) => <div key={i} className="flex gap-3 items-start" data-id="element-64">
                  <div className="mt-1 bg-green-500/20 p-1 rounded-full shrink-0" data-id="element-65">
                    <CheckIcon className="w-5 h-5 text-green-500" data-id="element-66" />
                  </div>
                  <p className="text-brand-cream font-bold" data-id="element-67">{item.good}</p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}